import React from "react";
import Spacer from "./components/spacer";
import Subscribe from "./components/subscribe";
import Footer from "./components/footer";

class Home extends React.Component {
  render() {
    var backgrounds = {
      gasStation: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/gas_station_right.png)'
      },
      mediterranean: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/mediterranean_left.png)'
      },
      rioDeJaneiro: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/rio_de_janeiro_right.png)'
      },
      sportArena: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/sport_arena_left.png)'
      },
      tajMahal: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/taj_mahal_right.png)'
      },
      spaceship: {
        backgroundImage: 'url(https://cdn.illpackus.com/backgrounds/spaceship_left.png)'
      }
    };
    document.body.classList.remove("inner-page");
    return (
      <div>
        {/* Navbar Section*/}
        <nav className="navbar navbar-expand-lg  theme-nav fixed-top">
          <div className="container">
            <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}>
              <img src="https://cdn.illpackus.com/logos/white_text.png" alt="" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#mainmenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="fa fa-align-justify" aria-hidden="true" />
              </span>
            </button>
            <div className="collapse navbar-collapse" id="mainmenu">
              <ul className="navbar-nav ml-auto" id="mymenu">
                <li className="nav-item ">
                  <a className="nav-link" href="#home">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#features">
                    Features
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#early-access">
                    Early Access
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Home One Section Start */}
        <section className="slide-bg theme-bg-confetti" id="home">
          <div className="container">
            <div className="row">
              <div className="col-md-6 order-2">
                <div className="d-flex-1">
                  <div className="slide-text">
                    <div>
                      <h1 className="main-title main-title-secondary"><span>Planning your group trip has never been easier.</span></h1>
                      <h3 className="text-white sign-up-prompt">
                        Sign up for early access!
                      </h3>
                      <div className="email-box early-access">
                        <div id="mc_embed_signup">
                          <form action="https://illpackus.us20.list-manage.com/subscribe/post?u=e0a5db6979af3e01641986a61&amp;id=953e127ddb" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" novalidate>
                            <div id="mc_embed_signup_scroll">
                              <div className="mc-field-group">
                                <input type="email" name="EMAIL" className="required email form-control" id="mce-EMAIL" placeholder="Email Address" />
                              </div>
                              <div id="mce-responses" className="clear">
                                <div className="response display-none" id="mce-error-response"></div>
                                <div className="response display-none" id="mce-success-response"></div>
                              </div>
                              <div className="mc-bot" aria-hidden="true"><input type="text" name="b_e0a5db6979af3e01641986a61_953e127ddb" tabindex="-1" value="" /></div>
                              <div className="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn btn-email" /></div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className="app-store">
                        <p className="text-white">
                          Available Soon On
                        </p>
                        <img src="https://cdn.illpackus.com/app_store.png" className="img-fluid" alt="" />
                        <img src="https://cdn.illpackus.com/google_play.png" className="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 order-1">
                <div className="home-center">
                  <div className="mobile-slid">
                    <h1 className="text-center"><img className="img-fluid main-logo" src="https://cdn.illpackus.com/logos/full.png" alt="" /></h1>
                    <img
                      src="https://cdn.illpackus.com/mockups/trio.png"
                      alt=""
                      className="img-fluid main-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Home One Section End */}

        <section className="theme-bg-right" style={backgrounds.gasStation} id="features">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-8 order-2 d-flex">
                <h1 className="feature-title feature-title-primary align-self-center"><span>Easily manage trip budgets and keep track of group fee payments.</span></h1>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 order-1">
                <div className="home-center">
                  <div className="mobile-slid">
                    <img
                      src="https://cdn.illpackus.com/mockups/payments.png"
                      alt=""
                      className="img-fluid feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Spacer />

        <section className="theme-bg-left" style={backgrounds.mediterranean}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-8 order-1 d-flex">
                <h1 className="feature-title feature-title-primary align-self-center"><span>In-app chat allows for easy group communication.</span></h1>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 order-2">
                <div className="home-center">
                  <div className="mobile-slid">
                    <img
                      src="https://cdn.illpackus.com/mockups/chat.png"
                      alt=""
                      className="img-fluid feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Spacer />

        <section className="theme-bg-right" style={backgrounds.rioDeJaneiro}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-8 order-2 d-flex">
                <h1 className="feature-title feature-title-primary align-self-center"><span>Intuitive itineraries make sure everyone is kept in the loop!</span></h1>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 order-1">
                <div className="home-center">
                  <div className="mobile-slid">
                    <img
                      src="https://cdn.illpackus.com/mockups/itinerary.png"
                      alt=""
                      className="img-fluid feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Spacer />

        <section className="theme-bg-left" style={backgrounds.sportArena}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-8 order-1 d-flex">
                <h1 className="feature-title feature-title-primary align-self-center"><span>Need inspiration? Explore trip ideas and experiences that other users have shared.</span></h1>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 order-2">
                <div className="home-center">
                  <div className="mobile-slid">
                    <img
                      src="https://cdn.illpackus.com/mockups/explore_2.png"
                      alt=""
                      className="img-fluid feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Spacer />

        <section className="theme-bg-right" style={backgrounds.tajMahal}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-8 order-2 d-flex">
                <h1 className="feature-title feature-title-primary align-self-center"><span>Share ideas, get opinions, or simply keep the group updated by posting to the trip feed.</span></h1>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 order-1">
                <div className="home-center">
                  <div className="mobile-slid">
                    <img
                      src="https://cdn.illpackus.com/mockups/trip_feed.png"
                      alt=""
                      className="img-fluid feature-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Spacer />

        {/*Subscription Component*/}
        <Subscribe />

        {/*Footer Component*/}
        <Footer />

        {/*tap-top*/}
        <div className="tap-top">
          <div>
            <i className="fa fa-angle-up" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home.js